import React from 'react';

// Full-page error shown when a page can't load its main data.
export function ErrorState({ title = 'Failed to load', message, onRetry }) {
    return (
        <div className="error-container">
            <div className="error-icon">⚠️</div>
            <div className="error-title">{title}</div>
            <div className="error-message">{message}</div>
            {onRetry && (
                <button className="btn btn-primary error-retry" onClick={onRetry}>
                    Try again
                </button>
            )}
        </div>
    );
}

// Inline banner for errors that shouldn't take over the whole page.
export function ErrorBanner({ message, onRetry, onDismiss }) {
    if (!message) return null;
    return (
        <div className="alert alert-error error-banner" role="alert">
            <span className="alert-icon">⚠️</span>
            <span className="error-banner-text">{message}</span>
            {onRetry && <button className="btn btn-ghost" onClick={onRetry}>Retry</button>}
            {onDismiss && (
                <button className="error-banner-dismiss" onClick={onDismiss} aria-label="Dismiss">✕</button>
            )}
        </div>
    );
}
